import PropTypes from "prop-types";
import {
  Divider,
  ListItemText,
  MenuItem,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { useTranslation } from "react-i18next";

export const compareTimeOptions = [
  {
    value: "15 MINUTES",
    ms: "15 Minit",
    en: "15 Minutes",
  },
  {
    value: "1 HOUR",
    ms: "1 Jam",
    en: "1 Hour",
  },
  {
    value: "4 HOURS",
    ms: "4 Jam",
    en: "4 Hours",
  },
  {
    value: "8 HOURS",
    ms: "8 Jam",
    en: "8 Hours",
  },
  {
    value: "1 DAY",
    ms: "1 Hari",
    en: "1 Day",
  },
  {
    value: "1 WEEK",
    ms: "1 Minggu",
    en: "1 Week",
  },
  {
    value: "1 MONTH",
    ms: "1 Bulan",
    en: "1 Month",
  },
];

export const PopoverCompareTime = (props) => {
  const {
    open = false,
    anchorEl,
    onClose,
    currentCompareTime,
    onCompareTimeChange,
  } = props;

  const { i18n } = useTranslation();

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
    >
      {compareTimeOptions.map((time) => {
        const isChecked = time.value === currentCompareTime;
        return (
          <div key={time.value}>
            <MenuItem onClick={() => onCompareTimeChange(time.value)}>
              <Stack
                direction={"row"}
                spacing={2}
                sx={{
                  justifyContent: "space-between",
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant="subtitle2">
                      {i18n.language === "ms" ? time.ms : time.en}
                    </Typography>
                  }
                />
                {isChecked && <CheckOutlinedIcon sx={{ fontSize: "1.2rem" }} />}
              </Stack>
            </MenuItem>
            <Divider sx={{ m: "0px !important" }} />
          </div>
        );
      })}
    </Popover>
  );
};

PopoverCompareTime.propTypes = {
  open: PropTypes.bool,
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  currentCompareTime: PropTypes.string,
  onCompareTimeChange: PropTypes.func,
};
